export const getParsedData = (data) => {
  if (typeof data !== 'string') {
    return data
  }

  let copy

  try {
    copy = JSON.parse(data)
  } catch (error) {
    return data
  }

  return copy
}